<div class="landing" [style.--landing-accent-color]="config.general?.background_color">
  <app-landing-hero [config]="config"></app-landing-hero>

  <main class="landing-body">
    <section
      class="landing-section"
      *ngFor="let section of sections"
      [attr.data-columns]="columns(section)"
    >
      <!-- El nombre de la sección solo se muestra si hay varias -->
      <h2 *ngIf="sections.length > 1">{{ section.name }}</h2>

      <div class="landing-cards">
        <article class="landing-card" *ngFor="let form of section.forms">
          <span class="landing-card-code">{{ formCode(form.number) }}</span>
          <h3>{{ form.number }}</h3>
          <p>{{ form.title }}</p>
          <p class="landing-card-subtitle" *ngIf="form.subtitle">{{ form.subtitle }}</p>
          <button type="button" class="landing-card-action" (click)="selectForm.emit(form)">
            Diligenciar
            <span class="material-icons">arrow_forward</span>
          </button>
        </article>
      </div>
    </section>
  </main>
</div>
